var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2673C0 5.63996 5.37262 0.267334 12 0.267334C18.6274 0.267334 24 5.63996 24 12.2673L12 13.3108L0 12.2673Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60547 18.2687C3.68039 21.8554 7.55808 24.2687 11.9997 24.2687C16.4414 24.2687 20.319 21.8554 22.394 18.2687L11.9997 17.4861L1.60547 18.2687Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3942 18.2673C23.4153 16.5023 24 14.4532 24 12.2673H0C0 14.4532 0.584719 16.5023 1.60575 18.2673H22.3942Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/COP.523c707719f5f82575221b489be8ded2.svg";